<template>
  <span
    :class="{ 'sb-pagination__placeholder': isPlaceholder }"
    data-testid="pagination-pages-information"
  >
    {{ text }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import i18n from '../../../i18n/index'

type paginationPagesTextProps = {
  currentPage?: number
  isPlaceholder?: boolean
  pages?: number
  showCurrentPage?: boolean
  locale?: string
}

const props = withDefaults(defineProps<paginationPagesTextProps>(), {
  currentPage: 1,
  isPlaceholder: false,
  pages: 1,
  showCurrentPage: false,
  locale: 'en',
})

const text = computed(() => {
  const ofTranslated = i18n(props.locale, 'of')
  const pageTranslated = i18n(props.locale, 'page')

  return props.showCurrentPage
    ? `${props.currentPage}/${props.pages}`
    : `${ofTranslated} ${props.pages}`
})
</script>
